import type { SVGProps } from "react";
export interface GripHrIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function GripHrIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: GripHrIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M21.124 14.75a1.375 1.375 0 0 1-2.742.14l-.008-.14.008-.141a1.375 1.375 0 0 1 1.368-1.233l.14.007c.694.07 1.234.655 1.234 1.367m0-5.5a1.374 1.374 0 0 1-2.742.141l-.008-.14.008-.141a1.375 1.375 0 0 1 1.368-1.235l.14.007a1.375 1.375 0 0 1 1.234 1.368m-5.166 5.5a1.375 1.375 0 0 1-2.743.14l-.007-.14.007-.141a1.375 1.375 0 0 1 1.369-1.233l.14.007c.693.07 1.233.655 1.233 1.367Zm0-5.5a1.374 1.374 0 0 1-2.743.141l-.007-.14.007-.141a1.375 1.375 0 0 1 1.369-1.235l.14.007a1.375 1.375 0 0 1 1.233 1.368Zm-5.167 5.5a1.375 1.375 0 0 1-2.742.14l-.008-.14.008-.141a1.375 1.375 0 0 1 1.368-1.233l.14.007c.694.07 1.234.655 1.234 1.367m0-5.5a1.374 1.374 0 0 1-2.742.141l-.008-.14.008-.141a1.375 1.375 0 0 1 1.368-1.235l.14.007a1.375 1.375 0 0 1 1.234 1.368m-5.166 5.5a1.375 1.375 0 0 1-2.743.14l-.007-.14.007-.141a1.375 1.375 0 0 1 1.368-1.233l.141.007c.693.07 1.233.655 1.234 1.367m0-5.5a1.374 1.374 0 0 1-2.743.141l-.007-.14.007-.141A1.375 1.375 0 0 1 4.25 7.875l.141.007A1.376 1.376 0 0 1 5.625 9.25"
      />
    </svg>
  );
}
